module.exports = __webpack_public_path__ + "static/telecommute-b681906e59f405d77cd55729c82366c9.png";